import { render, staticRenderFns } from "./ResetPwdView.vue?vue&type=template&id=35bda73c&"
import script from "./ResetPwdView.vue?vue&type=script&lang=js&"
export * from "./ResetPwdView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports